import React from "react";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import ProgressBar from "./ProgressBar";

const Breadcrumb = ({ title }) => {
const {is_client_admin} = JSON.parse(localStorage.getItem("user") || "{}");
  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        {/* Replace "Dashboard" with dynamic title */}
        <h6 className="fw-semibold mb-0">{title}</h6>

        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/dashboard"
              className="d-flex align-items-center gap-1 "
              style={{ color: `var(--text-primary-light)` }}
            >
              <Icon
                icon="solar:home-smile-angle-outline"
                className="icon text-lg"
              />
              Dashboard
            </Link>
          </li>
          <li> - </li>
          <li
            className="fw-medium"
            style={{ color: `var(--text-primary-light)` }}
          >
            {title}
          </li>
        </ul>
      </div>
      {is_client_admin && <ProgressBar />}
    </>
  );
};

export default Breadcrumb;
